import React from 'react';
import { Link } from 'react-router-dom';
import { Ruler, Wrench } from 'lucide-react';

const FiltrationCTABanner = () => {
  return (
    <div className="bg-gradient-to-r from-ctc-blue to-ctc-blue-dark shadow-lg sticky top-16 z-40">
      <div className="max-w-7xl mx-auto px-6 py-3">
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/contact"
            className="inline-flex items-center bg-white text-ctc-blue px-6 py-2 rounded-lg font-semibold hover:bg-gray-100 transition-colors text-sm"
          >
            <Ruler size={18} className="mr-2" />
            Size My Filter
          </Link>
          <Link
            to="/filtration/parts"
            className="inline-flex items-center bg-transparent border-2 border-white text-white px-6 py-2 rounded-lg font-semibold hover:bg-white hover:text-ctc-blue transition-colors text-sm"
          >
            <Wrench size={18} className="mr-2" />
            Parts & Service
          </Link>
        </div>
      </div>
    </div>
  );
};

export default FiltrationCTABanner;
